import { Chip, CssBaseline, FormHelperText, Grid, Stack } from "@mui/material";
import CalebAndBrownLogo from "src/icons/cnbDesktop";
import Box from "@mui/material/Box";
import { Formik } from "formik";
import { useHistory } from "react-router-dom";
import api from "src/store/features/api";
import * as Yup from "yup";
import {
  ResetPasswordContainer,
  FieldWrapper,
  Form,
  LoginLink,
  LogoBox,
  EmailField,
  SubmitButton,
} from "./styles/passwordReset.styles";
import { useTheme } from "@mui/styles";
import PublicIntercom from "../core/PublicIntercom";

export default function RequestForm() {
  const history = useHistory();
  const theme = useTheme();
  const [postPasswordReset] = api.useForgotPasswordMutation();

  const validationSchema = Yup.object().shape({
    email: Yup.string().email("Must be a valid email").max(255).required("Email is required"),
  });

  return (
    <ResetPasswordContainer>
      <CssBaseline />
      <Grid item xs={12}>
        <LogoBox>
          <CalebAndBrownLogo
            height={100}
            width="85%"
            color="currentColor"
            aria-label="Caleb & Brown"
          />
        </LogoBox>
        <Formik
          initialValues={{
            email: "",
            submit: null,
          }}
          onSubmit={async (values, { setStatus, setSubmitting }): Promise<void> => {
            try {
              let body = {
                email: values.email.toLowerCase(),
                redirect_url:
                  window.location.protocol + "//" + window.location.host + "/password/reset",
              };
              await postPasswordReset({
                forgotPasswordRequestDto: body,
              }).then(() => {
                history.push("/reset/request/success");
                setStatus({ success: true });
                setSubmitting(false);
              });
            } catch (err: any) {
              history.push("/reset/request/success");
              setStatus({ success: true });
              setSubmitting(false);
            }
          }}
          validationSchema={validationSchema}>
          {({ errors, handleSubmit, isSubmitting, touched, values, handleChange }): JSX.Element => (
            <Form noValidate onSubmit={handleSubmit}>
              <FieldWrapper item>
                <Stack direction={"row"} spacing="20px">
                  <EmailField
                    theme={theme}
                    fullWidth
                    name="email"
                    label="Email"
                    type="text"
                    value={values.email}
                    onChange={handleChange}
                    error={Boolean(touched.email && errors.email)}
                    helperText={touched.email && errors.email}
                    variant="filled"
                    InputProps={{
                      disableUnderline: true,
                    }}
                  />
                </Stack>
              </FieldWrapper>
              {errors.submit && (
                <Box>
                  <FormHelperText error>{errors.submit}</FormHelperText>
                </Box>
              )}
              <SubmitButton
                color="secondary"
                disabled={isSubmitting}
                fullWidth
                size="large"
                type="submit"
                variant="contained">
                Email Password Reset Link
              </SubmitButton>
            </Form>
          )}
        </Formik>
        <Grid container justifyContent="center" sx={{ padding: "40px" }}>
          <LoginLink>
            Back to{" "}
            <Chip label="Login" variant="outlined" component="a" href="/" clickable size="small" />
          </LoginLink>
        </Grid>
      </Grid>
      <PublicIntercom />
    </ResetPasswordContainer>
  );
}
